/** biome-ignore-all lint/style/useNamingConvention: Existing gallery data uses camel case for display name */

export type ActiveFilter = {
  filterSection: string;
  filterName: string;
  on: boolean;
};

export enum SortByOption {
  MOST_POPULAR = 'most_popular',
  TRENDING = 'trending',
  NEWLY_ADDED = 'newly_added',
}

export type FilterType = {
  display_name: string;
  on: boolean;
  enabled: boolean;
};

export type FilterGroupType = {
  display_name: string;
  filters: Record<string, FilterType>;
};

export type FilterGroupsType = Record<string, FilterGroupType>;
